export default {
  strict: true,
  namespaced: true,
  state: {
    configuration: {}
  },
  mutations: {
    setConfiguration (state, value) { state.configuration = value },
    setConfigurationItem (state, item) { state.configuration[item.key].value = item.value }
  }
}



// WEBPACK FOOTER //
// ./src/store/settings-page.js